import q from "q";

var getUserItems = function () {
    var userData = {};
    var user = JSON.parse(localStorage.getItem('user'));
    if (user) {
        userData.token = user.accessToken;
        userData.userId = user.userProfile.loginId;
        userData.tenantId = user.userProfile.tenantId;
    }
    return userData;
}

// local
// var baseurl = "http://credit.localhost.jumbotail.com:3000/";
// test
// var baseurl = "https://credit-beta.jumbotail.com/";

// prod
var baseurl = "https://braavos.jumbotail.com/";

var preProdUrl = "http://preprod.api.jumbotail.com:8989/";

var http = function (tinurl, method, content) {
    var userData = getUserItems();
    var url = baseurl + tinurl;
    method.headers = {
        Accept: "*/*"
    };

    if (userData.token) {
        method.headers['Authorization'] = 'Bearer ' + userData.token;
        method.headers['userid'] = userData.userId;
        method.headers['tenantId'] = userData.tenantId;
    }

    if (content) {
        method.headers["content-type"] = content;
    }
    method.credentials = "include";
    var deferred = q.defer();
    fetch(url, method)
        .then(response => {
            return response.json();
        })
        .then(response => {
            console.log("Received " + tinurl + " response: ", response);
            if (response.statusCode !== 200) {
                deferred.reject({ error: response.error });
                return;
            }
            if (response.data) {
                deferred.resolve(response.data);
            } else {
                deferred.resolve(response);
            }
        })
        .catch(function (e) {
            console.log("Request to " + tinurl + " failed: ", e);
            deferred.reject(e);
        });
    return deferred.promise;
};
var httpPreProd = function (tinurl, method, content) {
    var userData = getUserItems();
    var url = preProdUrl + tinurl;
    method.headers = {
        Accept: "*/*"
    };

    if (userData.token) {
        method.headers['Authorization'] = 'Bearer ' + userData.token;
        method.headers['userid'] = userData.userId;
        method.headers['tenantId'] = userData.tenantId;
    }

    if (content) {
        method.headers["content-type"] = content;
    }
    method.credentials = "include";
    var deferred = q.defer();
    fetch(url, method)
        .then(response => {
            return response.json();
        })
        .then(response => {
            console.log("Received " + tinurl + " response: ", response);
            if (response.statusCode !== 200) {
                deferred.reject({ error: response.error });
                return;
            }
            if (response.data) {
                deferred.resolve(response.data);
            } else {
                deferred.resolve(response);
            }
        })
        .catch(function (e) {
            console.log("Request to " + tinurl + " failed: ", e);
            deferred.reject(e);
        });
    return deferred.promise;
};

var httpIngestion = function (tinurl, method, content) {
    var userData = getUserItems();
    var url = baseurl + tinurl;
    method.headers = {
        Accept: "*/*"
    };

    if (userData.token) {
        method.headers['Authorization'] = 'Bearer ' + userData.token;
        method.headers['userid'] = userData.userId;
        method.headers['tenantId'] = userData.tenantId;
    }

    if (content) {
        method.headers["content-type"] = content;
    }
    method.credentials = "include";
    var deferred = q.defer();
    fetch(url, method)
        .then(response => {
            if (response.status !== 200) {
                return response.json();
            }
            return response;
        })
        .then(response => {
            console.log("Received " + tinurl + " response: ", response);
            if (response.statusCode && response.statusCode !== 200) {
                deferred.reject({ error: response.error });
                return;
            }
            if (response.data) {
                deferred.resolve(response.data);
            } else {
                var data = response;
                var mime = response.headers.get("Content-Type");
                var fileName = response.headers.get("Content-Disposition").match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                var name = fileName[1];
                deferred.resolve({ data: data, mime: mime, name: name });
                // deferred.resolve(response);
            }
        })
        .catch(function (e) {
            console.log("Request to " + tinurl + " failed: ", e);
            deferred.reject(e);
        });
    return deferred.promise;
}

var fileDownloadHttp = function (tinurl, method, content) {
    var userData = getUserItems();
    var deferred = q.defer();
    var url = baseurl + tinurl;
    method.headers = {
        Accept: "*/*"
    };

    if (userData.token) {
        method.headers['Authorization'] = 'Bearer ' + userData.token;
        method.headers['userid'] = userData.userId;
        method.headers['tenantId'] = userData.tenantId;
    }

    if (content) {
        method.headers["content-type"] = content;
    }
    method.credentials = "include";
    fetch(url, method)
        .then(function (response) {
            var data = response;
            var mime = response.headers.get("Content-Type");
            var fileName = response.headers.get("Content-Disposition").match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            var name = fileName[1];
            deferred.resolve({ data: data, mime: mime, name: name });
        })
        .catch(function (e) {
            console.log("Unable to process your request.", e);
            deferred.reject(e);
        });
    return deferred.promise;
};

const apiHandler = {
    post: function (url, data) {
        return http(url, { method: "POST", body: JSON.stringify(data) }, "application/json");
    },

    postPreProd: function (url, data) {
        return httpPreProd(url, { method: "POST", body: JSON.stringify(data) }, "application/json");
    },

    postIngestion: function (url, data) {
        return httpIngestion(url, { method: "POST", body: data });
    },

    put: function (url, data) {
        return http(url, { method: "PUT", body: JSON.stringify(data) }, "application/json");
    },

    // Alias to make GET API http calls.
    get: function (url, params) {
        return http(url, { method: "GET" }, "application/json");
    },

    fileDownloadHttpGet: function (url, params) {
        return fileDownloadHttp(url, { method: "GET", params: params }, "application/json");
    },

    fileDownloadHttpPost: function (url, request) {
        return fileDownloadHttp(url, { method: "POST", body: JSON.stringify(request) }, "application/json");
    }
};

export default apiHandler;



// WEBPACK FOOTER //
// ./src/utilities/apiHandler.js